import TScrollBar from './scroll-bar.vue'

TScrollBar.install = Vue => {
  Vue.component(TScrollBar.name, TScrollBar)
}

export default TScrollBar



// WEBPACK FOOTER //
// ./src/module/scroll-bar/index.js